var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625.25H3.375a3.01 3.01 0 00-3 3v12a3.01 3.01 0 003 3H4.5l-1.35 1.8a.75.75 0 001.2.9l2.025-2.7h5.25l2.025 2.7a.75.75 0 001.2-.9l-1.35-1.8h1.125a3.01 3.01 0 003-3v-12a3.01 3.01 0 00-3-3zm-9.75 15a1.125 1.125 0 110-2.25 1.125 1.125 0 010 2.25zm3.375-6H1.875V5.5H8.25v3.75zm4.875 6a1.125 1.125 0 110-2.25 1.125 1.125 0 010 2.25zm3-6H9.75V5.5h6.375v3.75z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/transport.f747cd6f4a196b3d382528ac08ad3273.svg";
export { ForwardRef as ReactComponent };